export const SET_MOBILE = 'SET_MOBILE';
export const SET_VERIFICATION_CODE_ERROR = 'SET_VERIFICATION_CODE_ERROR';
export const SET_RESET_DATA = 'SET_RESET_DATA';
